module.exports = __webpack_public_path__ + "img/5_Middle-A.c038048f.png";